import { render, staticRenderFns } from "./radio-secondary.vue?vue&type=template&id=6e64f30d&scoped=true&"
import script from "./radio-secondary.vue?vue&type=script&lang=js&"
export * from "./radio-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e64f30d",
  null
  
)

export default component.exports